<div class="modal-wrapper">
	<div class="modal-header">
		<div class="modal-header-content">
			<h1 class="modal-title">Add fund</h1>
			<p class="modal-subtitle"> Select the following options to create a new fund.</p>
		</div>
		<i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
	</div>
	<div class="modal-body form-container">
		<ng-container *ngFor='let tabConfiguration of tabsConfig'>
      <div class="config form-group">
        <div class="name-container">
          <label class="label" [class.text-error]="!tabConfiguration.choosen_value && submitted">{{tabConfiguration.name}}</label>
        </div>
        <input
          type="text"
          class="form-control"
          *ngIf='tabConfiguration.name === "Fund Name"; else selectCustom'
          [(ngModel)]="tabConfiguration.choosen_value"
          placeholder='Insert value'
          [class.is-invalid]="!tabConfiguration.choosen_value && submitted"
        >
        <small
          class="text-error"
          *ngIf="!tabConfiguration.choosen_value && submitted">
          {{tabConfiguration.name === "Fund Name" ? 'Fund Name is mandatory. Please fill the field!' : 'Choose an option'}}
        </small>
        <ng-template #selectCustom>
          <ng-select
            class='custom select-custom-config select-check-value'
            [clearable]="false"
            bindLabel="value"
            bindValue="id"
            [(ngModel)]='tabConfiguration.choosen_value'
            [searchable]="false"
            [items]='tabConfiguration.values'
            placeholder='Select an option'
            [class.is-invalid]="!tabConfiguration.choosen_value && submitted"
          >
          </ng-select>
        </ng-template>
      </div>
    </ng-container>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss('Cross click')">Cancel</button>
		<button class="btn btn-default" type='submit' (click)="confirmData()">Create</button>
	</div>
</div>
  